/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["section[_ngcontent-%COMP%]{text-align:center;background:#b62027;color:#fff;padding:1% 10%;margin:9% 26% 7em;font-family:Montserrat-Light,sans-serif}img[_ngcontent-%COMP%]{width:60px;background:#fff;border-radius:50%;padding:15px;margin:0 auto}.thank[_ngcontent-%COMP%]{font-size:2rem}@media(max-width:767px){section[_ngcontent-%COMP%]{padding:1% 0;margin:9%}}\n/*# sourceMappingURL=bpg-membership-preview-success.component.css.map*/"];
export { styles as styles };
